<mat-dialog-content class="acm-paywall">
  <div class="acm-paywall__card">
    <div class="acm-paywall__preview">
      <p class="acm-paywall__preview-label">
        {{ 'CHANGE_MONITORING.PAYWALL_EXAMPLE_ALERT_LABEL' | translate }}
      </p>

      <div class="acm-paywall__demo-card">
        <div class="acm-paywall__demo-header">
          <span class="acm-paywall__severity">
            {{ 'CHANGE_MONITORING.PAYWALL_SEVERITY_HIGH' | translate }}
          </span>
          <span class="acm-paywall__demo-title">
            {{ 'CHANGE_MONITORING.PAYWALL_DEMO_ALERT_TITLE' | translate }}
          </span>
        </div>

        <div class="acm-paywall__demo-summary">
          {{ 'CHANGE_MONITORING.PAYWALL_DEMO_ALERT_SUMMARY' | translate }}
        </div>

        <div class="acm-paywall__demo-row acm-paywall__demo-row--bordered">
          <span class="acm-paywall__demo-key">
            {{ 'CHANGE_MONITORING.PAYWALL_FIELD_AFFECTED_USERS' | translate }}
          </span>
          <span class="acm-paywall__chip acm-paywall__chip--muted">
            {{ 'CHANGE_MONITORING.PAYWALL_DEMO_USER_EMAIL' | translate }}
          </span>
        </div>
        <div class="acm-paywall__demo-row">
          <span class="acm-paywall__demo-key">
            {{ 'CHANGE_MONITORING.PAYWALL_FIELD_OPERATION' | translate }}
          </span>
          <span class="acm-paywall__pill acm-paywall__pill--amber">
            {{ 'CHANGE_MONITORING.PAYWALL_DEMO_OPERATION' | translate }}
          </span>
        </div>
        <div class="acm-paywall__demo-row">
          <span class="acm-paywall__demo-key">
            {{ 'CHANGE_MONITORING.PAYWALL_FIELD_ACCESS' | translate }}
          </span>
          <span class="acm-paywall__demo-value">
            {{ 'CHANGE_MONITORING.PAYWALL_DEMO_ACCESS' | translate }}
          </span>
        </div>
        <div class="acm-paywall__demo-row">
          <span class="acm-paywall__demo-key">
            {{ 'CHANGE_MONITORING.PAYWALL_FIELD_DETECTED_AT' | translate }}
          </span>
          <span class="acm-paywall__demo-value">
            {{ 'CHANGE_MONITORING.PAYWALL_DEMO_DETECTED_AT' | translate }}
          </span>
        </div>
        <div class="acm-paywall__demo-row">
          <span class="acm-paywall__demo-key">
            {{ 'CHANGE_MONITORING.PAYWALL_FIELD_PERFORMED_BY' | translate }}
          </span>
          <span class="acm-paywall__demo-value">
            {{ 'CHANGE_MONITORING.PAYWALL_DEMO_PERFORMED_BY' | translate }}
          </span>
        </div>

        <div class="acm-paywall__demo-footer">
          <span class="acm-paywall__demo-footer-label">
            {{ 'CHANGE_MONITORING.PAYWALL_FIELD_CONTROLLER' | translate }}
          </span>
          <span class="acm-paywall__demo-footer-value">
            {{ 'CHANGE_MONITORING.PAYWALL_DEMO_CONTROLLER' | translate }}
          </span>
        </div>
      </div>
    </div>

    <div class="acm-paywall__main">
      <div class="acm-paywall__intro">
        <h1 class="acm-paywall__headline">
          {{ 'CHANGE_MONITORING.PAYWALL_HEADLINE' | translate }}
        </h1>
        <p class="acm-paywall__body">{{ 'CHANGE_MONITORING.PAYWALL_BODY' | translate }}</p>
      </div>

      <div class="acm-paywall__cta">
        <q9-primary-button type="button" data-qa="acm-paywall-book-call" (click)="bookACall()">
          {{ 'CHANGE_MONITORING.PAYWALL_BOOK_A_CALL' | translate }}
        </q9-primary-button>
      </div>

      <div class="acm-paywall__features">
        <div *ngFor="let f of features" class="acm-paywall__feature">
          <span class="acm-paywall__feature-title">{{ f.titleKey | translate }}</span>
          <span class="acm-paywall__feature-desc">{{ f.bodyKey | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
